// Kanoniczne grupy produktów używane w galerii realizacji i na stronie głównej sklepu.
export const PRODUCT_GROUPS = [
  "T-SHIRT'Y",
  "POLO",
  "POLARY",
  "KURTKI",
  "CZAPKI",
  "BLUZY",
  "INNE",
];
